export enum TransactionCategorySelectViewState {
  CategorySelect = "CategorySelect",
}

export interface TransactionCategorySelectViewForm {
  categories: Array<string>,
}
